import { atom, selector } from "recoil";
import { AtomObj } from "models/general";
import dayjs from "dayjs";
import { getSymptomData } from "services/symptom.service";
import { GERMAN_DATE_FORMAT } from "constants/date-time";
/**
 * Selector to fetch symptom question answers for the selected month.
 * It retrieves symptom data from an external service based on the selected date.
 */

export const getSymptomQuestionAnswerSelector = selector({
  key: "getSymptomQuestionAnswerSelector",
  get: async ({ get }) => {
    // Get the selected date from the activeDateAtom (calendar)
    const selectedDate = get(activeDateAtom);
    const refreshTrigger = get(refreshTriggerStateAtom); // trigger api oncemore once refreshstate
    if (refreshTrigger) {
      try {
        // Fetch symptom data from the API for the selected month's range
        const symptomData = await getSymptomData({
          start_date: selectedDate
            ? dayjs(selectedDate).startOf("month").format(GERMAN_DATE_FORMAT)
            : undefined, // Start of the month
          end_date: selectedDate
            ? dayjs(selectedDate).endOf("month").format(GERMAN_DATE_FORMAT)
            : undefined, // End of the month
        });

        // If the API call was successful, return the symptom data
        if (
          symptomData &&
          (symptomData.status === 200 || symptomData?.data.status === 200)
        ) {
          return symptomData.data.data;
        }
      } catch (error) {
        console.error(error);
        return [];
      }
    }
    // Return an empty array if no data was returned or the request failed
    return [];
  },
});

/**
 * get symptom track values
 */
const getSymptomTrack: AtomObj = {
  key: "getSymptomTrack",
  default: {
    none: false,
    tracker: "",
  },
};

/**
 * get symptom category
 */
const getSymptomCategoryId: AtomObj = {
  key: "getSymptomCategoryId",
  default: "",
};

const questionbyCatrgorySelector: AtomObj = {
  key: "questionbyCatrgorySelector",
  default: null,
};

/**
 * user selected date will set here
 */
const activeDate: AtomObj = {
  key: "activeDate",
  default: dayjs().startOf("day").format(GERMAN_DATE_FORMAT),
};

/**
 * symptom category api response
 */
const symptomCategoryList: AtomObj = {
  key: "symptomCategoryList",
  default: [],
};

/**
 * symptom category api response
 */
const symptomQuestionAnswer: AtomObj = {
  key: "symptomQuestionAnswer",
  default: getSymptomQuestionAnswerSelector,
};

/**
 * horizontal calender active date
 */
const horizontalCalenderActiveDate: AtomObj = {
  key: "horizontalCalenderActiveDate",
  default: null,
};

/**
 * selected and previous answers
 */
const selectedAndPreviousAnswers: AtomObj = {
  key: "selectedAndPreviousAnswers",
  default: null,
};

/**
 * refresh triggering
 */
const refreshTriggerState: AtomObj = {
  key: "refreshTrigger", // unique ID
  default: 1,
};

/**
 * tracker page reload triggering
 */
const trackerReloadState: AtomObj = {
  key: "trackerReload", // unique ID
  default: false,
};
export const symptomTrackState = atom(getSymptomTrack);
export const symptomCategoryIDAtom = atom(getSymptomCategoryId);
export const questionbyCatrgorySelectorAtom = atom(questionbyCatrgorySelector);
export const activeDateAtom = atom(activeDate);
export const symptomCategoryListAtom = atom(symptomCategoryList);
export const symptomQuestionAnswerAtom = atom(symptomQuestionAnswer);
export const horizontalCalenderActiveDateAtom = atom(
  horizontalCalenderActiveDate,
);
export const selectedAndPreviousAnswersAtom = atom(selectedAndPreviousAnswers);
export const refreshTriggerStateAtom = atom(refreshTriggerState);
export const trackerReloadStateAtom = atom(trackerReloadState);
